import React from 'react';
import PropTypes from 'prop-types';

import '../styles/common.css';
import {ReactComponent as Icon1} from '../images/euro-icon.svg';
import {ReactComponent as Icon2} from '../images/deal-icon.svg';
import {ReactComponent as Icon3} from '../images/office-icon.svg';
import NewInfoBlock from '../components/NewInfoblock';
import '../styles/new-info-blocks.css';

class NewHome extends React.Component {
  render() {
    return (
      <div className="new-info-blocks-container">
        <NewInfoBlock headingLevel="h2" title="home-debitors_title" desc="home-debitors_desc">
          <Icon1 style={{height: '100px'}} />
        </NewInfoBlock>
        <NewInfoBlock headingLevel="h2" title="home-client_title" desc="home-client_desc">
          <Icon2 style={{height: '100px'}} />
        </NewInfoBlock>
        <NewInfoBlock headingLevel="h2" title="home-agency_title" desc="home-agency_desc">
          <Icon3 style={{height: '100px'}} />
        </NewInfoBlock>
      </div>
    );
  }
}

NewHome.propTypes = {
  organisaatioId: PropTypes.number
};

export default NewHome;
